var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.styles),attrs:{"src":_vm.computedImage,"alt":_vm.STRINGS.AVATAR},on:{"error":function () { return (_vm.error = true); }}})}
var staticRenderFns = []

export { render, staticRenderFns }